module.exports = __webpack_public_path__ + "img/info_hover.349f3b1f.png";